import * as types from '../constants/drugstore_cart';
import _find from 'lodash/find';
import _get from 'lodash/get';
import localStorage from 'store';
import api from '../api';
import toast from '../utils/toast';
import qs from 'qs';
import { calcDistance } from '../utils/map';
import _pickBy from 'lodash/pickBy';
import hydrateVErrors from '../utils/vErrors';
import _round from 'lodash/round';
import {
  calculateOnePackage,
  calculateOnePartOfThePackage,
  isDivisible,
} from '../utils/cart';
import _sumBy from 'lodash/sumBy';
import i18n from '../i18n';

export const syncLocation = () => (dispatch, getState) =>
  dispatch(setLocation(getState().user.location));

export const setLocation = payload => dispatch => {
  dispatch({
    type: types.SET_LOCATION,
    payload,
  });

  localStorage.set('cart_location', payload);

  dispatch(setMapCenter(payload));
};

export const setMapCenter = payload => async dispatch => {
  dispatch({
    type: types.SET_MAP_CENTER,
    payload,
  });
};

const updateServerCart = goodsId => (dispatch, getState) => {
  try {
    let uid = getState().user.uuid;
    let cartItems = getState().cart.items;
    let item = _find(cartItems, { id: goodsId }) || { in_cart: 0 };
    let form = {
      uid,
      goods_id: goodsId,
      quantity: item.in_cart,
    };
    api.post('/cart', form);
  } catch (e) {
    console.error(e);
  }
};

export const addToCart = item => (dispatch, getState) => {
  let cartItems = getState().cart.items;
  let exist = _find(cartItems, { id: item.id });

  if (exist) {
    if (!exist.quantity) {
      toast.error({
        message: i18n.t("labels.can't_add"),
        placement: 'bottomRight',
      });

      return;
    }

    if (Math.round(exist.in_cart) >= Math.round(exist.quantity)) {
      toast.error({
        message: i18n.t("labels.can't_add"),
        placement: 'bottomRight',
      });

      return;
    }

    cartItems = cartItems.map(i => {
      if (i.id === item.id && i.in_cart < i.quantity) {
        if (isDivisible(i.pack_info)) {
          i.in_cart += calculateOnePackage(i);
        } else {
          i.in_cart++;
        }
      }

      return i;
    });
  } else {
    let newItem = {
      ...item,
      in_cart: isDivisible(item.pack_info) ? calculateOnePackage(item) : 1,
    };
    cartItems.push({ ...newItem });
    cartItems = [...cartItems];
  }

  dispatch({
    type: types.ADD_TO_CART,
    payload: cartItems,
  });
  localStorage.set('cart_items', cartItems);
  dispatch(updateServerCart(item.id));

  return true;
};

export const addPartToCart = item => (dispatch, getState) => {
  let cartItems = getState().cart.items;
  let exist = _find(cartItems, { id: item.id });

  if (exist) {
    if (!exist.quantity) {
      toast.error({
        message: i18n.t("labels.can't_add"),
        placement: 'bottomRight',
      });

      return;
    }

    if (Math.round(exist.in_cart) >= Math.round(exist.quantity)) {
      toast.error({
        message: i18n.t("labels.can't_add"),
        placement: 'bottomRight',
      });

      return;
    }

    cartItems = cartItems.map(i => {
      if (i.id === item.id && i.in_cart < i.quantity) {
        i.in_cart += calculateOnePartOfThePackage();
      }

      return i;
    });
  } else {
    let newItem = {
      ...item,
      in_cart: 1,
    };
    cartItems.push({ ...newItem });
    cartItems = [...cartItems];
  }

  dispatch({
    type: types.ADD_TO_CART,
    payload: cartItems,
  });
  localStorage.set('cart_items', cartItems);
  dispatch(updateServerCart(item.id));
};

export const removeFromCart = (item, remove = false, unit = false) => (
  dispatch,
  getState
) => {
  //todo logging activity about removing from cart
  //todo this place for removing items from card
  //this also can work as -- from shopping cart page
  //we can to this via filtering data
  let cartItems = getState().cart.items;
  let itemInCart = _find(cartItems, { id: item.id });
  //fixme better to throw exception
  if (!itemInCart) return;

  if (itemInCart.in_cart >= 1 && !remove) {
    cartItems = cartItems.map(i => {
      if (i.id === item.id) {
        if (isDivisible(i.pack_info)) {
          i.in_cart -= calculateOnePackage(i);
        } else {
          i.in_cart--;
        }
      }

      return i;
    });
  } else {
    cartItems = cartItems.filter(i => i.id !== item.id);
  }

  dispatch({
    type: types.ADD_TO_CART,
    payload: cartItems,
  });
  localStorage.set('cart_items', cartItems);
  dispatch(updateServerCart(item.id));
};

export const removePartFromCart = (item, remove = false) => (
  dispatch,
  getState
) => {
  //todo logging activity about removing from cart
  //todo this place for removing items from card
  //this also can work as -- from shopping cart page
  //we can to this via filtering data
  let cartItems = getState().cart.items;
  let itemInCart = _find(cartItems, { id: item.id });
  //fixme better to throw exception

  if (!itemInCart) return;

  if (itemInCart.in_cart >= 1 && !remove) {
    cartItems = cartItems.map(i => {
      if (i.id === item.id) {
        if (isDivisible(i.pack_info)) {
          i.in_cart -= calculateOnePartOfThePackage(i);
        } else {
          i.in_cart--;
        }
      }

      return i;
    });
  } else {
    cartItems = cartItems.filter(i => i.id !== item.id);
  }

  dispatch({
    type: types.ADD_TO_CART,
    payload: cartItems,
  });
  localStorage.set('cart_items', cartItems);
  dispatch(updateServerCart(item.id));
};

export const setItemCount = (id, value, name) => (dispatch, getState) => {
  let items = getState().cart.items;

  if (value === 0) {
    items = items.filter(i => i.id !== id);
  } else {
    items = items.map(i => {
      if (i.id === id) {
        i.in_cart = value;
      }

      return i;
    });
  }

  dispatch({
    type: types.SET_CART_ITEM_COUNT,
    payload: items,
  });
  dispatch(updateServerCart(id));
};

const loadingOffersMethod = async getState => {
  let mapCenter = getState().cart.mapCenter;
  let userLocation = getState().cart.location;
  let cartItems = getState().cart.items;

  let items = cartItems.map(i => {
    let isPartial = isDivisible(i.pack_info);
    let quantity = isPartial
      ? _round(i.in_cart / i.pack_info.quantity_unit_in_pack, 4)
      : i.in_cart;

    return {
      goods_id: parseInt(i.id),
      quantity,
    };
  });

  let params = {
    items,
    latitude: mapCenter ? mapCenter.latitude : null,
    longitude: mapCenter ? mapCenter.longitude : null,
  };

  let queryString = qs.stringify(params);
  let { data } = await api.get('/order/drugstores', {
    params,
    paramsSerializer: () => queryString,
  });

  return data.map(i => {
    let order = i.order;

    if (order) {
      order.completeness = {
        ...order.completeness,
        full: order.completeness.total === order.completeness.complete,
      };
    }

    let goods = _get(order, 'goods', []).map(good => {
      let { pack_info } = _find(cartItems, { id: good.goods_id });
      let isPartial = isDivisible(pack_info);
      let quantity = good.quantity;
      let online_total = _round(quantity * good.online_price, 2);
      let drugstore_total = _round(quantity * good.drugstore_price, 2);

      let payload = isPartial
        ? {
            online_total,
            drugstore_total,
            is_partial: true,
          }
        : null;

      return {
        ...good,
        ...payload,
      };
    });

    let onlinePrice = _sumBy(goods, 'online_total');
    let drugstorePrice = _sumBy(goods, 'drugstore_total');

    return {
      ...i,
      order: {
        ...order,
        goods: goods,
        /**
         * we set NULL to online drugstore and distance as when
         * we need sort results then null results will be in the end
         */
        online_total: onlinePrice ? onlinePrice.toFixed(2) : null,
        drugstore_total: drugstorePrice ? drugstorePrice.toFixed(2) : null,
      },
      distance: onlinePrice ? calcDistance(userLocation, i.coordinates) : null,
    };
  });
};

export const fetchDrugstoreForOrder = () => async (dispatch, getState) => {
  try {
    if (!getState().cart.items.length) {
      dispatch({ type: types.FETCH_DRUGSTORES_SUCCESS, payload: [] });

      return;
    }
    dispatch({ type: types.FETCH_DRUGSTORES });
    let data = await loadingOffersMethod(getState);
    dispatch({ type: types.FETCH_DRUGSTORES_SUCCESS, payload: data });
  } catch (e) {
    console.error(e);
    dispatch({ type: types.FETCH_DRUGSTORES_ERROR });
  }
};

export const loadMoreOffers = () => async (dispatch, getState) => {
  try {
    if (!getState().cart.items.length) {
      return;
    }

    dispatch({ type: types.LOAD_MORE_OFFERS_REQUEST });
    let data = await loadingOffersMethod(getState);
    dispatch({ type: types.LOAD_MORE_OFFERS_SUCCESS, payload: data });
  } catch (e) {
    console.error(e);
    dispatch({ type: types.LOAD_MORE_OFFERS_ERROR });
  }
};

export const selectOffer = offerId => (dispatch, getState) => {
  try {
    if (offerId) {
      let offers = getState().cart.pharmacyOffers;
      let cartItems = getState().cart.items;
      let found = _find(offers, { id: offerId });

      found = {
        ...found,
        order: {
          ...found.order,
          goods: found.order.goods.map(i => {
            let fromCart = _find(cartItems, { id: i.goods_id });

            return {
              ...i,
              in_cart: fromCart.in_cart,
              goods_name: fromCart.goods_name,
              release_form: fromCart.release_form,
              name: fromCart.name,
              name_uk: fromCart.name_uk,
              name_ru: fromCart.name_ru,
              goods_producer: fromCart.goods_producer,
              _id: fromCart._id,
              nds: typeof fromCart.nds === 'number' ? fromCart.nds : i.nds,
            };
          }),
          online_total: _sumBy(found.order.goods, 'online_total'),
          drugstore_total: _sumBy(found.order.goods, 'drugstore_total'),
        },
      };

      dispatch({ type: types.SELECT_OFFER, payload: found });
    } else {
      dispatch({ type: types.SELECT_OFFER, payload: null });
    }
  } catch (e) {
    console.error(e);
    toast.error({
      message: e.message,
    });
  }
};

export const storeOrderFailure = payload => dispatch => {
  dispatch({
    type: types.STORE_ORDER_ERROR,
    payload,
  });
};

export const setVErrors = payload => ({
  type: types.SET_V_ERRORS,
  payload,
});

const setLoader = payload => ({
  type: types.SET_LOADER,
  payload,
});

export const storeOrder = payload => async (dispatch, getState) => {
  try {
    let { uuid } = getState().user;
    let cartState = getState().cart;
    let offer = cartState.selectedOffer;
    let userLocation = cartState.location;

    let form = _pickBy(
      {
        uid: uuid,
        user_location: userLocation,
        drugstore_location: offer.coordinates,
        first_name: payload.first_name,
        second_name: payload.second_name,
        last_name: payload.last_name,
        phone: payload.phone.replace(/\+/, ''),
        email: payload.email,
        drugstore_id: offer.id,
        franchising_percentage: payload.franchising_percentage,
        insurance_number: payload.insurance_number,
        ...offer.order,
        goods: offer.order.goods.map(i => ({
          ...i,
        })),
        drugstore_total: _round(offer.order.drugstore_total, 2),
        total: _round(offer.order.online_total, 2),
        _recaptcha: payload._recaptcha,
      },
      v => v !== null && v !== undefined && v !== ''
    );

    dispatch(setLoader(true));
    const {
      data: { data },
    } = await api.post('/order/store', form);
    dispatch({ type: types.STORE_ORDER_SUCCESS, payload: data });
    toast.success({
      message: i18n.t('messages.info.thank_you_for_order'),
      placement: 'bottomright',
    });
    dispatch(flushCart());
    dispatch(setLoader(false));

    return true;
  } catch (e) {
    console.error(e);
    dispatch(storeOrderFailure());
    dispatch(setVErrors(hydrateVErrors(e)));
    dispatch(setLoader(false));
  }
};

export const flushCart = () => dispatch => {
  dispatch({ type: types.FLUSH_ALL });
  localStorage.remove('cart_items');
};

export const flushConfirm = () => dispatch => {
  dispatch({ type: types.FLUSH_CONFIRM });
};

export const prefillForm = () => async (dispatch, getState) => {
  try {
    let uuid = getState().user.uuid;
    dispatch({ type: types.PRELOAD_FORM_REQUEST });
    dispatch(flushConfirm());
    let { data } = await api.get(`/order/prefill-form/${uuid}`);
    dispatch({ type: types.PRELOAD_FORM_SUCCESS });

    return data;
  } catch (e) {
    console.error(e);
    dispatch({ type: types.PRELOAD_FORM_ERROR });
  }
};
